import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminPageInitialState, AdminPageTypes } from './admin.state.ts';
import {
  getReceptionCenters,
  saveReceptionSettings,
  saveStationSetup,
} from 'store/feature/admin_page/admin.thunk.ts';
import { QueryState } from '@/common/enum';
import { ISettingsEntity } from 'interfaces/settings.interface.ts';

const initialState: AdminPageTypes = AdminPageInitialState;

export const adminPageSlice = createSlice({
  name: 'adminPage',
  initialState,
  reducers: {
    UPDATE_STATION_SETTINGS: (state, action: PayloadAction<ISettingsEntity>) => {
      state.stationSettings = action.payload;
    },
    UPDATE_STATE_STATUS: (state, action: PayloadAction<QueryState>) => {
      state.queryState = action.payload;
    },
    UPDATE_NEW_ENTRY: (state, action: PayloadAction<boolean>) => {
      state.newEntry = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReceptionCenters.pending, (state) => {
        state.queryState = QueryState.AWAIT;
        state.error = null;
      })
      .addCase(getReceptionCenters.fulfilled, (state, action) => {
        state.queryState = QueryState.READY;
        state.receptionCenters =
          (action.payload &&
            action.payload?.dataset &&
            action.payload.dataset.length &&
            action.payload.dataset) ||
          [];
      })
      .addCase(getReceptionCenters.rejected, (state, action) => {
        state.queryState = QueryState.FAIL;
        state.error = action.error.message || 'Something went wrong!';
      })
      .addCase(saveStationSetup.fulfilled, (state, action) => {
        if (action.payload) {
          state.stationSettings = action.payload;
          state.newEntry = false;
        }
      })
      .addCase(saveReceptionSettings.fulfilled, (state, action) => {
        // stationSettings is otherwise only loaded at login; merge saved reception
        // settings back in so the SELECT OPTIONS modal rebuilds its post lists
        // from current data instead of the stale login-time snapshot.
        if (!state.stationSettings) return;
        const saved = action.meta.arg;
        state.stationSettings.reception = state.stationSettings.reception.map((reception) =>
          String(reception.id) === String(saved.id)
            ? {
                ...reception,
                settingsS1: { ...reception.settingsS1, ...saved.settingsS1 },
                settingsS2: { ...reception.settingsS2, ...saved.settingsS2 },
                settingsS3: { ...reception.settingsS3, ...saved.settingsS3 },
              }
            : reception
        );
      });
  },
});

export default adminPageSlice.reducer;
